import MyProfileView from "../../features/profile/MyProfileView";

const MyProfilePage = () => <MyProfileView />;

export default MyProfilePage;
